import {
  OwnerAppointmentListActionTypes,
  OWNER_APPOINTMENT_LIST_FAIL,
  OWNER_APPOINTMENT_LIST_LOADING,
  OWNER_APPOINTMENT_LIST_SUCCESS,
  OwnerAppointmentListState,
  OWNER_APPOINTMENT_LIST_UPDATE_API_MSG,
  OWNER_APPOINTMENT_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { OwnerAppointmentResponse } from "./Model";

const initialStateGetPosts: OwnerAppointmentListState = {
  loading: false,
  ownerAppointmentListResponse: {} as OwnerAppointmentResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const ownerAppointmentListReducer = (
  state = initialStateGetPosts,
  action: OwnerAppointmentListActionTypes
): OwnerAppointmentListState => {
  switch (action.type) {
    case OWNER_APPOINTMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case OWNER_APPOINTMENT_LIST_SUCCESS:
      return {
        ...state,
        ownerAppointmentListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case OWNER_APPOINTMENT_LIST_FAIL:
      return {
        ...state,
        ownerAppointmentListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case OWNER_APPOINTMENT_LIST_UPDATE_API_MSG:
      return {
        ...state,
        ownerAppointmentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case OWNER_APPOINTMENT_LIST_UPDATE_API_RES:
      return {
        ...state,
        ownerAppointmentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
